import type { BrowserPhoneUser } from './types';

export const SIP_CONFIG_REFRESH_INTERVAL_MS = 15_000;

export function sipCredentialRegenerationAvailability(user: BrowserPhoneUser, hasUnsavedChanges: boolean) {
  if (hasUnsavedChanges) {
    return { allowed: false, reason: 'Сначала сохраните изменения сотрудника' };
  }
  if (!user.browser_phone_enabled || !/^\d{2,6}$/.test(String(user.extension || '')) || !user.has_sip_password) {
    return { allowed: false, reason: 'Сначала включите и настройте браузерный телефон' };
  }
  if (user.sip_credentials_state === 'ROTATING') {
    return { allowed: false, reason: 'Перегенерация SIP-доступа уже выполняется' };
  }
  if (user.sip_credentials_state === 'REPAIR_REQUIRED') {
    return { allowed: false, reason: 'Сначала восстановите конфигурацию FreeSWITCH в диагностике' };
  }
  return { allowed: true, reason: '' };
}

export function sipCredentialActionLabel(user: BrowserPhoneUser) {
  return user.sip_credentials_state === 'REVOCATION_PENDING'
    ? 'Повторить сброс старой SIP-регистрации'
    : 'Перегенерировать SIP-доступ';
}
